import {
  ApiBlueprint,
  PageBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { discoveryApiRef, fetchApiRef } from '@backstage/core-plugin-api';
import { wireguardApiRef } from './api/WireguardApi';
import { WireguardClient } from './api/WireguardClient';

const wireguardApi = ApiBlueprint.make({
  params: define =>
    define({
      api: wireguardApiRef,
      deps: { fetchApi: fetchApiRef, discoveryApi: discoveryApiRef },
      factory: ({ fetchApi, discoveryApi }) =>
        new WireguardClient({ fetchApi, discoveryApi }),
    }),
});

const wireguardPage = PageBlueprint.make({
  params: {
    path: '/wireguard',
    loader: () =>
      import('./components/WireguardPage').then(m => <m.WireguardPage />),
  },
});

export const wireguardPlugin = createFrontendPlugin({
  pluginId: 'wireguard',
  extensions: [wireguardApi, wireguardPage],
});

export default wireguardPlugin;
